import React from 'react'
import styled from 'styled-components'
import CopyHelper from '../Copy'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: flex-start;
  width: 100%;
  margin-top: 32px;
`

const SectionTitle = styled.div`
  font-family: 'Inter Display', sans-serif;
  font-weight: 600;
  font-size: 32px;
  color: white;
  line-height: 1.4;
`

const CardsGrid = styled.div`
  display: flex;
  gap: 20px;
  width: 100%;

  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
`

const Card = styled.div`
  flex: 1;
  background: #1b1c21;
  border-radius: 16px;
  padding: 32px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  height: 132px;
  justify-content: center;
  align-items: flex-start;
  min-width: 0;
`

const CardLabel = styled.p`
  font-family: 'Inter Display', sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.5);
  line-height: 1.4;
  margin: 0;
  width: 100%;
`

const CardValue = styled.p`
  font-family: 'Inter Display', sans-serif;
  font-weight: 500;
  font-size: 18px;
  color: white;
  line-height: 1.4;
  margin: 0;
  white-space: nowrap;
`

const AddressContainer = styled.div`
  background: rgba(34, 35, 40, 0.8);
  backdrop-filter: blur(8px);
  border: 1px solid #222328;
  border-radius: 32px;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 40px;
  box-sizing: border-box;
`

const AddressText = styled.p`
  font-family: 'Inter Display', sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: white;
  line-height: 1.4;
  margin: 0;
  white-space: nowrap;
`

const ExplorerButton = styled.div`
  background: #222328;
  backdrop-filter: blur(8px);
  border-radius: 32px;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 40px;
  box-sizing: border-box;
  cursor: pointer;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.8;
  }
`

const ExplorerText = styled.p`
  font-family: 'Inter Display', sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: white;
  line-height: 1.4;
  margin: 0;
  white-space: nowrap;
`

const TokenInformationSection = ({ symbol, name, address }) => {
  const formatAddress = (addr) => {
    if (!addr) return 'N/A'
    return `${addr.slice(0, 6)}...${addr.slice(-4)}`
  }

  const handlePolygonscanClick = () => {
    if (address) {
      window.open(`https://polygonscan.com/address/${address}`, '_blank')
    }
  }

  // Better data handling - check for undefined, null, empty string
  const displaySymbol = symbol && symbol !== '' ? symbol : 'Loading...'
  const displayName = name && name !== '' ? name : 'Loading...'

  return (
    <Container>
      <SectionTitle>Token Information</SectionTitle>

      <CardsGrid>
        {/* Symbol Card */}
        <Card>
          <CardLabel>Symbol</CardLabel>
          <CardValue>{displaySymbol}</CardValue>
        </Card>

        {/* Name Card */}
        <Card>
          <CardLabel>Name</CardLabel>
          <CardValue>{displayName}</CardValue>
        </Card>

        {/* IXS Address Card */}
        <Card>
          <CardLabel>IXS Address</CardLabel>
          <AddressContainer>
            <AddressText>{formatAddress(address)}</AddressText>
            <CopyHelper toCopy={address || ''} />
          </AddressContainer>
        </Card>

        {/* Polygonscan Card */}
        <Card>
          <CardLabel>Polygonscan</CardLabel>
          <ExplorerButton onClick={handlePolygonscanClick}>
            <ExplorerText>View on Polygonscan</ExplorerText>
          </ExplorerButton>
        </Card>
      </CardsGrid>
    </Container>
  )
}

export default TokenInformationSection
